import { render } from "./a-project-card.vue?vue&type=template&id=22c32e29&scoped=true"
import script from "./a-project-card.vue?vue&type=script&lang=js"
export * from "./a-project-card.vue?vue&type=script&lang=js"

import "./a-project-card.vue?vue&type=style&index=0&id=22c32e29&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c32e29"]])

export default __exports__